import React, { useEffect, useState } from "react";
import { Form, Modal } from "react-bootstrap";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import SettingSidebar from "../components/Setttingsidebar";
import { Link } from "react-router-dom";
import axios from "axios";
import "../App.css";
import { ApiUrl, videoUrl } from '../Constants/Weburl'
import CustomTable from "../components/CustomTable";
import CustomButton from "../components/CustomButton";
import CustomSwitch from "../components/Customswitch";
import CustomPagination from '../components/Custompagination'
import CustomContainer from "../components/Customsettingscontain";
import CustomInput from '../components/Custominput';
import { useSearchParams } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import DeleteModal from "../components/DeleteModal";
import Layout from "../components/Layout";
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";



const getImageUrl = (ApiUrl, img) => {
    if (!img) return "";
    if (img.startsWith("http")) return img;
    return `${ApiUrl}${img.replace("\\", "/")}`;
};

const getVideoUrl = (videoUrl, path) => {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return `${videoUrl}${path}`;
};

export default function Lives() {

    const [allhashtag, setAllhashtag] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [inputValue, setInputValue] = useState("");

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const urlSearch = searchParams.get("search") || "";

    // const [searchText, setSearchText] = useState(urlSearch);

    const [alluser, setAllUsers] = useState([]);


    const location = useLocation();


    //add hashtag state
    const [hashtags, setHashtags] = useState([]);
    const [newHashtag, setNewHashtag] = useState("");
    const [editingId, setEditingId] = useState(null);
    const [editingText, setEditingText] = useState("");

    const staticLives = [
        {
            id: 1,
            username: "Pragya346",
            fullname: "Pragya",
            profilePic: "https://i.pravatar.cc/100?img=32",
            title: "Hello My dear lovely friends, Good Morning"
        },
        {
            id: 2,
            username: "lisa1234",
            fullname: "lisa",
            profilePic: "https://i.pravatar.cc/100?img=47",
            title: "---"
        }
    ];

    const [showAddModal, setShowAddModal] = useState(false);
    //   useEffect(() => {
    //     fetchAllUsers()
    //   }, [])

    //   const fetchAllUsers = async () => {
    //     try {
    //       const token = localStorage.getItem("adminToken");

    //       const res = await axios.get(
    //         `${ApiUrl}api/auth/allusers`,
    //         {
    //           headers: {
    //             Authorization: `Bearer ${token}`,
    //           },
    //         }
    //       );

    //       console.log("all users response", res.data.users);
    //       setAllUsers(res.data.users);
    //     }
    //     catch (e) {
    //       console.log("error", e);
    //     }
    //   };

    const [alllives, setAllLives] = useState([]);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [selectedLive, setSelectedLive] = useState(null);


    //toggleexpand code

    const { toggleExpand, isExpanded } = useExpandableRows();

    const liveHeaders = [
        { label: "Users", key: "Users", className: 'ht-col-name' },
        { label: "Lives", key: "Lives", className: 'ht-col-count' },
        { label: "Action", key: "Action", className: 'ht-col-action' },
    ];
    const hiddenFields = useHiddenColumns(".rr1-table", liveHeaders);




    const handleLivevideo = (livevideo) => {
        setSelectedLive(livevideo);
        setIsViewModalOpen(true);
    }

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize, searchText]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get("search");

        if (searchParam) {
            console.log("Search term from URL:", searchParam);
            setSearchText(searchParam);
            setInputValue(""); // dropdown-la irundhu vandha input empty
        }
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get("search");

        if (searchParam && searchParam !== searchText) {
            console.log("Search term updated from URL:", searchParam);

            setSearchText(searchParam);
            setCurrentPage(1);
        }
    }, [location.search]);

    useEffect(() => {
        fetchEndedLives();
    }, []);


    const filteredLives = alllives.filter((item) => {
        const search = searchText.toLowerCase().trim();

        if (!search) return true;

        return (
            item?.host?.username?.toLowerCase().includes(search) ||
            item?.host?.name?.toLowerCase().includes(search) ||
            item?.liveId?.toLowerCase().includes(search)
        );
    });

    // getendedlivedata
    const fetchEndedLives = async () => {
        try {

            const res = await fetch(
                `${ApiUrl}api/getendlivedata`
            );

            const result = await res.json();

            console.log("ended lives admin:", result);

            if (result.success) {
                setAllLives(result.data);
            }

        } catch (err) {
            console.log(err);
        }
    }


    //deleteliverecords
    const admindeleteLiverecords = async (id) => {
        console.log("id admindeleteliveddata", id);
        try {
            const token = localStorage.getItem("adminToken");

            const res = await axios.delete(
                `${ApiUrl}api/admindelliverecords/${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            console.log("res admindeleteliverecords", res.data)

            setAllLives(prev => prev.filter(p => p.liveId !== id));

        } catch (error) {
            console.error("Delete post failed", error);
        }
    };


    const handleSearchChange = (e) => {
        const value = e.target.value;

        setInputValue(value);
        setSearchText(value);
        setCurrentPage(1);

        const params = new URLSearchParams(location.search);

        if (value) {
            params.set("search", value);
        } else {
            params.delete("search");
        }

        navigate(
            `${location.pathname}?${params.toString()}`,
            { replace: true }
        );
    };

    return (
        <div className="layout">
            <Layout>

                <CustomContainer className="rr-wrapperhashtag" fluid="false">
                    {/* <div className="rr-card"> */}

                    <div className="ht-header-bar">
                        {/* <div className="wds-tabs-row"> */}
                        <h3 className="ht-page-title">Livestream</h3>




                        <div className="ht-header-right">
                            <div className="rr-left">
                                Show
                                <select
                                    className="rr-select"
                                    value={pageSize}
                                    onChange={(e) => setPageSize(Number(e.target.value))}>
                                    <option>5</option>
                                    <option>10</option>
                                    <option>25</option>
                                    <option>50</option>
                                </select>
                                entries
                            </div>

                            <div className="rr-right">
                                <span>Search:</span>
                                <CustomInput
                                    className="rr-search"
                                    type="text"
                                    value={inputValue}
                                    onChange={handleSearchChange}
                                    placeholder="Search hashtag"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="rr-card">

                        <CustomTable headers={liveHeaders} className="rr1-table hashtag-table">
                            {filteredLives.length === 0 ? (
                                <tr>
                                    <td colSpan="3" style={{ textAlign: "center", padding: 20 }}>
                                        No lives found
                                    </td>
                                </tr>
                            ) : (
                                // filteredLives.map((item) => (

                                //     <React.Fragment key={item.host.id}>
                                //         <tr className="rr-actionshastag">

                                //             {/* USER COLUMN */}
                                //             <td className="ht-col-name">
                                //                 <div className="profile-pill">

                                //                     {hiddenFields.length > 0 && (
                                //                         <button
                                //                             type="button"
                                //                             className={`row-expand-toggle ${isExpanded(item.id ?? idx) ? "is-open" : ""
                                //                                 }`}
                                //                             onClick={() => toggleExpand(item.id ?? idx)}
                                //                             aria-label="Show more details"
                                //                         >
                                //                             {isExpanded(item.id ?? idx) ? "−" : "+"}
                                //                         </button>
                                //                     )}

                                //                     <div className="avatar-wrapper">
                                //                         <img
                                //                             src={getImageUrl(ApiUrl, item?.host.avatar)}
                                //                             alt=""
                                //                             style={{
                                //                                 width: 40,
                                //                                 height: 40,
                                //                                 borderRadius: "50%",
                                //                             }}
                                //                         />
                                //                     </div>

                                //                     <div className="user-info">
                                //                         <div className="username">{item.host.username}</div>
                                //                         <div className="fullname">{item.host.name}</div>
                                //                     </div>

                                //                 </div>
                                //             </td>

                                //             {/* TITLE COLUMN */}
                                //             <td className="ht-col-count">
                                //                 <CustomButton
                                //                     className="view-btn"
                                //                     onClick={() => handleLivevideo(item)}
                                //                 >
                                //                     <i className="bi bi-play" style={{ fontSize: '20px' }}></i> View Content
                                //                 </CustomButton>
                                //             </td>

                                //             <td className="ht-col-action rr-actions">
                                //                 <CustomButton
                                //                     reportclassName="rr-icon-btn red"
                                //                     onClick={() => admindeleteLiverecords(item.liveId)}
                                //                 >
                                //                     <i className="bi bi-trash"></i>
                                //                 </CustomButton>
                                //             </td>

                                //         </tr>


                                //     </React.Fragment>
                                // ))
                                filteredLives.map((item) => {
                                    const rowId = item.liveId ?? item.host?.id;

                                    return (
                                        <React.Fragment key={rowId}>

                                            {/* MAIN ROW */}
                                            <tr className="rr-actionshastag">

                                                {/* USER COLUMN */}
                                                <td className="ht-col-name">
                                                    <div className="profile-pill">

                                                        {hiddenFields.length > 0 && (
                                                            <button
                                                                type="button"
                                                                className={`row-expand-toggle ${isExpanded(rowId) ? "is-open" : ""
                                                                    }`}
                                                                onClick={() => toggleExpand(rowId)}
                                                                aria-label="Show more details"
                                                            >
                                                                {isExpanded(rowId) ? "−" : "+"}
                                                            </button>
                                                        )}

                                                        <div className="avatar-wrapper">
                                                            <img
                                                                src={getImageUrl(ApiUrl, item?.host?.avatar)}
                                                                alt=""
                                                                style={{
                                                                    width: 40,
                                                                    height: 40,
                                                                    borderRadius: "50%",
                                                                }}
                                                            />
                                                        </div>

                                                        <div className="user-info">
                                                            <div className="username">
                                                                {item?.host?.username}
                                                            </div>

                                                            <div className="fullname">
                                                                {item?.host?.name}
                                                            </div>
                                                        </div>

                                                    </div>
                                                </td>

                                                {/* LIVES COLUMN */}
                                                <td className="ht-col-count">
                                                    <CustomButton
                                                        className="view-btn"
                                                        onClick={() => handleLivevideo(item)}
                                                    >
                                                        <i
                                                            className="bi bi-play"
                                                            style={{ fontSize: "20px" }}
                                                        ></i>

                                                        View Content
                                                    </CustomButton>
                                                </td>

                                                {/* ACTION COLUMN */}
                                                <td className="ht-col-action rr-actions">
                                                    <CustomButton
                                                        reportclassName="rr-icon-btn red"
                                                        onClick={() =>
                                                            admindeleteLiverecords(item.liveId)
                                                        }
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                    </CustomButton>
                                                </td>

                                            </tr>


                                            {/* EXPANDED ROW */}
                                            {isExpanded(rowId) && hiddenFields.length > 0 && (
                                                <tr className="row-expand-details">
                                                    <td colSpan={3}>
                                                        <div className="expand-details">

                                                            {hiddenFields.map(({ field, label }) => (
                                                                <div
                                                                    className="expand-item"
                                                                    key={field}
                                                                >
                                                                    <span className="expand-label">
                                                                        {label}
                                                                    </span>


                                                                    {/* USER */}
                                                                    {field === "ht-name" && (
                                                                        <div className="expand-value">
                                                                            <div className="chip">

                                                                                <img
                                                                                    src={getImageUrl(
                                                                                        ApiUrl,
                                                                                        item?.host?.avatar
                                                                                    )}
                                                                                    alt=""
                                                                                    style={{
                                                                                        width: 40,
                                                                                        height: 40,
                                                                                        borderRadius: "50%",
                                                                                    }}
                                                                                />

                                                                                <div>
                                                                                    <div
                                                                                        style={{
                                                                                            fontWeight: 600,
                                                                                            fontSize: 14,
                                                                                            color: "#111",
                                                                                        }}
                                                                                    >
                                                                                        {item?.host?.username}
                                                                                    </div>

                                                                                    <div
                                                                                        style={{
                                                                                            fontSize: 13,
                                                                                            color: "#6b7280",
                                                                                        }}
                                                                                    >
                                                                                        {item?.host?.name}
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    )}


                                                                    {/* LIVE */}
                                                                    {field === "ht-count" && (
                                                                        <div className="expand-value">
                                                                            <CustomButton
                                                                                className="view-btn"
                                                                                onClick={() =>
                                                                                    handleLivevideo(item)
                                                                                }
                                                                            >
                                                                                <i
                                                                                    className="bi bi-play"
                                                                                    style={{
                                                                                        fontSize: "20px",
                                                                                    }}
                                                                                ></i>

                                                                                View Content
                                                                            </CustomButton>
                                                                        </div>
                                                                    )}


                                                                    {/* ACTION */}
                                                                    {field === "ht-action" && (
                                                                        <div
                                                                            className="expand-value"
                                                                            style={{
                                                                                display: "flex",
                                                                                gap: 8,
                                                                            }}
                                                                        >
                                                                            <CustomButton
                                                                                reportclassName="rr-icon-btn red"
                                                                                onClick={() =>
                                                                                    admindeleteLiverecords(
                                                                                        item.liveId
                                                                                    )
                                                                                }
                                                                            >
                                                                                <i className="bi bi-trash"></i>
                                                                            </CustomButton>
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            ))}

                                                        </div>
                                                    </td>
                                                </tr>
                                            )}

                                        </React.Fragment>
                                    );
                                })
                            )}
                        </CustomTable>



                        <div className="rr-footer">
                            <span>
                                Showing 1 to {alllives.length} of {alllives.length} entries
                            </span>

                            <CustomPagination
                                currentPage={currentPage}
                                totalPages={totalPages || 1}
                                onPageChange={(page) => setCurrentPage(page)}
                                className="rr-pagination"
                                pageClassName="rr-page"
                                activeClassName="active"
                                ellipsisClassName="rr-page"
                            />

                        </div>
                    </div>
                    {/* </div> */}
                </CustomContainer>

                <Modal
                    show={isViewModalOpen && selectedLive !== null}
                    onHide={() => setIsViewModalOpen(false)}
                    centered
                    dialogClassName="modal-box"
                >
                    {selectedLive && (
                        <>
                            <Modal.Header style={{ borderBottom: "none", position: "relative" }}>
                                <CustomButton
                                    className="close-btn"
                                    onClick={() => setIsViewModalOpen(false)}
                                >
                                    ✕
                                </CustomButton>
                                <Modal.Title style={{ marginTop: "-5px" }}>View Content</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div className="content-preview" style={{ width: "100%" }}>
                                    {selectedLive.videoPath ? (
                                        <video
                                            src={getVideoUrl(videoUrl, selectedLive.videoPath)}
                                            type="video/mp4"
                                            controls
                                            style={{
                                                width: "100%",
                                                height: "400px",
                                                objectFit: "contain",
                                                borderRadius: 10,
                                            }}
                                        >
                                            Your browser does not support video.
                                        </video>
                                    ) : (
                                        <p>No media yet</p>
                                    )}
                                </div>
                            </Modal.Body>
                        </>
                    )}
                </Modal>

            </Layout>
        </div>
    );
}

